import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import _ from "i18n";

export default function SidePageHeader({
  subHeader,
  actionButton,
  isUAVersion,
  handleSetCurrentPage,
  returnTo,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const goBack = () => {
    if (isUAVersion) {
      handleSetCurrentPage("LIST_PAGE");
    } else if (query.get("returnto")) {
      window.location.href = query.get("returnto");
    } else if (returnTo) {
      navigate(returnTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="side-page-header">
      <div className="side-page-header__info">
        <button className="btn side-page-header__button" onClick={goBack}>
          <img src="/img/icons/arrow-right.svg" alt="Retour" />
          <span>{_("return")}</span>
        </button>
        <p className="sub-header">{_(subHeader)}</p>
      </div>

      {actionButton?.action && (
        <div className="side-page-header__action">
          <button
            className="btn secondary side-page-header__button"
            onClick={actionButton.action}
          >
            <i className={`icon-left ${actionButton.icon}`} />
            <span>{actionButton.label}</span>
          </button>
        </div>
      )}
    </div>
  );
}